import { connect } from 'react-redux'
import StatsControlsPresentation from '../presentations/StatsControls/StatsControlsPresentation'

import { overlayToggle } from '../actions/overlay'
import { openStatisticCenter } from '../actions/statisticCenter'
import { toggleCarouselManualmode } from '../actions/carousel'
import { getActiveChannelId, getOverlayVisibility } from '../reducers/gui'
import { getSeasonId } from '../reducers/matches'
import { getMatchIdByChannelId } from '../reducers/timings'
import { getStatisticCenterBaseUrl } from '../reducers/bookmakerOptions'
import { getLanguage, getS5Alias } from '../reducers/config'

const mapStateToProps = ( state: any, ownProps: { direction: 'horizontal'|'vertical' } ) => ({
  visible: getOverlayVisibility(state),
  matchid: getMatchIdByChannelId( state, getActiveChannelId( state ) ),
  seasonid: getSeasonId( state ),
  statisticCenterBaseUrl: getStatisticCenterBaseUrl( state ),
  lang: getLanguage( state ),
  s5Alias: getS5Alias( state )
})

const mapDispatcherToProps = ( dispatch: Function ) => ({
  overlayToggle: () => dispatch(overlayToggle()),
  toggleCarouselManualmode: () => dispatch(toggleCarouselManualmode()),
  openStatisticCenter: () => dispatch(openStatisticCenter()),
})

const StatsControls = connect( mapStateToProps, mapDispatcherToProps )( StatsControlsPresentation )

export default StatsControls